import { create } from 'zustand';

type TRefetchItemStore = {
  refetchEnabled: boolean;
  setRefetchEnabled: (enabled: boolean) => void;
};

const useRefetchItemStore = create<TRefetchItemStore>((set) => ({
  refetchEnabled: true,
  setRefetchEnabled: (enabled) => set({ refetchEnabled: enabled }),
}));

export default useRefetchItemStore;
